import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "userCheckFilled"
const UserCheckFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M22.939 15.158 16.326 22.875 11.625 18.175 13.02 16.778 16.214 19.972 21.44 13.875z" />
          <path d="M10.5 13.125C13.942 13.125 16.067 14.223 17.38 15.578L16.102 17.07 13.02 13.989 8.834 18.174 11.285 20.625H1.5S1.5 13.125 10.5 13.125M10.875 1.5C13.567 1.5 15.75 3.683 15.75 6.375S13.567 11.25 10.875 11.25 6 9.067 6 6.375 8.183 1.5 10.875 1.5" />
        </svg>
      }
    </span>
  )
}
export default UserCheckFilledIcon
